import React, { useState, useEffect, useRef } from 'react';
import { FaChevronDown } from 'react-icons/fa';
import './CustomDropdown.css'; // We will create this next

const CustomDropdown = ({ options, placeholder, name, value, onChange }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const selectedLabel = options.find(opt => opt.value === value)?.label || placeholder;

    return (
        <div className="custom-dropdown" ref={dropdownRef}>
            <div className={`dropdown-header ${isOpen ? 'active' : ''}`} onClick={() => setIsOpen(!isOpen)}>
                <span>{selectedLabel}</span>
                <FaChevronDown className={`chevron ${isOpen ? 'rotate' : ''}`} />
            </div>
            {isOpen && (
                <div className="dropdown-list">
                    {options.map((opt) => (
                        <div
                            key={opt.value}
                            className="dropdown-item"
                            onClick={() => {
                                onChange({ target: { name, value: opt.value } });
                                setIsOpen(false);
                            }}
                        >
                            {opt.label}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default CustomDropdown;